<template>
  <v-flex 
    sm6 
    md6 
    lg6 
    class="text-xs-center">
    <v-card>
      <v-card-text ref="card">
        <div 
          v-show="printer_off" 
          style="width: 100%; height: 100%;">
          <div 
            :data-share-badge-id="badge.id" 
            data-iframe-width="auto" 
            data-iframe-height="260"/>
        </div>
        <div 
          v-show="!printer_off" 
          id="print-badge">
          <div id="badge">
            <a 
              target="_blank" 
              href="https://www.youracclaim.com/badges/1dc267bd-b7aa-4887-a672-7a1016368dd7/embedded"><img 
                width="105" 
                height="105" 
                alt="" 
                src="https://acclaim-production-app.s3.amazonaws.com/images/78e39333-d0db-4931-b231-13bdb37040cc/Programming%2Bin%2BC_23-01.png">
              <span id="badge-name">{{ badge.printName }}</span>
            </a><div 
              id="badge-issuer" 
              :title="badge.printIssuer">
              Issuer:
              {{ badge.printIssuer }}
            </div>
          </div>
          <div id="provided">
            <a 
              target="_blank" 
              href="/">Provided by
              <span>Acclaim</span>
          </a></div>
        </div>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<style lang="scss" scoped v-if="false">
#print-badge {
    html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video {
        margin:0;
        padding:0;
        border:0;
        font-size:100%;
        font:inherit;
        vertical-align:baseline
    }
    article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section {
        display:block
    }
    body {
        line-height:1
    }
    ol,ul {
        list-style:none
    }
    blockquote,q {
        quotes:none
    }
    blockquote:before,blockquote:after,q:before,q:after {
        content:"";
        content:none
    }
    table {
        border-collapse:collapse;
        border-spacing:0
    }
    body {
        border:1px solid #e5e5e5;
        color:#333;
        font-family:Helvetica, Arial, "Lucida Grande", sans-serif;
        font-size:0.88rem;
        padding:22px 0 0;
        text-align:center;
        -moz-border-radius:3px;
        -webkit-border-radius:3px;
        border-radius:3px
    }
    a {
        text-decoration:none
    }
    img {
        margin:0 0 22px
    }
    #badge-name {
        color:#333;
        display:block;
        font-size:1rem;
        line-height:1.1em;
        margin:0 8px 8px
    }
    #badge-expired {
        color:#ffffff;
        background-color:#aa0000;
        text-transform:uppercase;
        font-size:0.5rem;
        display:inline-block;
        padding:0 4px;
        line-height:15px;
        margin-bottom:8px
    }
    #badge-issuer {
        color:#666;
        font-size:0.81rem;
        font-style:italic;
        line-height:1.1em;
        margin:0 8px;
        max-width:100%;
        overflow:hidden
    }
    #provided {
        background:#f0f0f0;
        border-top:1px solid #e2e2e2;
        color:#b6b6b6;
        font-size:0.44rem;
        line-height:28px;
        margin:18px 0 0;
        text-transform:uppercase;
        -moz-border-radius:0 0 3px 3px;
        -webkit-border-radius:0 0 3px 3px;
        border-radius:0 0 3px 3px
    }
    #provided a{
        color:#b6b6b6;
        text-decoration:none
    }
    #provided span{
        background-image:url(https://cdn.youracclaim.com/assets/embed/acclaim-4574247db5852ba31840afbf6bf296e6eb9ea290b8c2e54c147814344ca2e58f.png);
        background-size:37px 9px;
        background-position:left 7px;
        background-repeat:no-repeat;
        display:inline-block;
        height:28px;
        text-indent:-99999px;
        vertical-align:middle;
        width:37px
    }
}
</style>

<script type="text/javascript">
export default {
    props: {
        badge: {
          type: Object,
          default: null
        },
        printer_off: {
          type: Boolean,
          default: true
        }
    },
    mounted() {
        (function() {
            var s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = '//cdn.youracclaim.com/assets/utilities/embed.js';
            var o = document.getElementsByTagName('script')[0];
            o.parentNode.insertBefore(s, o);
        })();
    },
}
</script>